import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DraggableMenuSelector, showMenu } from './reducers/DraggableMenuReducer';
import './DraggableMenu.scss';
import Draggable from 'react-draggable';
import { setComponentType, showQuickInput } from '../QuickInput/reducers/QuickInputReducer';
import { ComponentType } from '../SavedSearch/SavedSearch';

const DraggableMenu: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const draggableMenuSelector = useSelector(DraggableMenuSelector);

    useEffect(() => {
        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (event.altKey) {
            switch (event.key) {
                case "1":
                    showComponent(ComponentType.Tonnage);
                    break;
                case "2":
                    showComponent(ComponentType.Cargo);
                    break;
                default:
                    break;
            }
        }
    }, []);

    const showComponent = (componentType: ComponentType) => {
        dispatch(showQuickInput(true));
        dispatch(setComponentType(componentType));
    }

    return (
        <>
            <Draggable>
                <div
                    id="draggableMenu"
                    onClick={() => {
                        dispatch(showMenu(!draggableMenuSelector.showMenu));
                    }}
                >
                    <div><i className="fa fa-bars" aria-hidden="true"></i></div>
                    <div className={"sub-menu " + (draggableMenuSelector.showMenu ? "" : "sub-menu-hidden ")}>
                        <div
                            className='menu1'
                            onClick={() => {
                                showComponent(ComponentType.Tonnage);
                            }}
                        >Tonnage (1)</div>
                        <div className='menu2'
                            onClick={() => {
                                showComponent(ComponentType.Cargo);
                            }}
                        >Cargo (2)</div>
                    </div>
                </div>
            </Draggable>
        </>
    )
};

export default DraggableMenu;